import { ReactNode, useState } from 'react'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { Input } from '@tribeplatform/react-ui-kit/Input'

export type LinkPickerProps = {
  placeholder?: string
  helper?: ReactNode
  onChange: (url: string) => void
}

export const LinkPicker: React.FC<LinkPickerProps> = ({
  placeholder = 'Paste an image link...',
  helper = 'Works with any image from the web',
  onChange,
}) => {
  const [link, setLink] = useState<string>('')

  return (
    <div className="flex flex-col items-center justify-center max-w-full mx-auto">
      <Input
        value={link}
        onChange={e => setLink(e?.target?.value)}
        placeholder={placeholder}
        name="link"
        wrapperClassName="w-full"
      />
      <Button
        className="mt-3"
        onClick={() => {
          onChange(link)
        }}
      >
        Submit
      </Button>
      {helper && (
        <FormControl.HelperText className="mt-3">
          {helper}
        </FormControl.HelperText>
      )}
    </div>
  )
}
